import { useCallback, useEffect, useState } from 'react';
import AdminPageHeader from '../components/AdminPageHeader';
import AdminTable from '../components/AdminTable';
import LoadStatus from '../components/LoadStatus';
import StatusBadge from '../components/StatusBadge';
import { getAiClientResults } from './aiClientApi';
import { AI_CLIENT_STATUS_LABELS, formatDuration } from './aiClientStatus';

const COLUMNS = [
    { key: 'practiced_at', label: '진행일', className: 'nowrap muted' },
    { key: 'user', label: '사용자', className: 'nowrap', render: row => <>{row.user_name || '—'}<br /><span className="muted">{row.user_email}</span></> },
    { key: 'client_name', label: 'AI 내담자', className: 'nowrap' },
    { key: 'topic', label: '연습 주제', render: row => row.topic || '—' },
    { key: 'duration_minutes', label: '면담 시간', className: 'nowrap', render: formatDuration },
    { key: 'status', label: '상태', render: row => <StatusBadge label={AI_CLIENT_STATUS_LABELS[row.status] || row.status} done={row.status === 'completed'} /> },
];

// 상세 화면 경로를 만든다.
function toDetailPath(row) {
    return `/admin/ai-clients/${encodeURIComponent(row.instance_id)}`;
}

// 사용자들의 AI 내담자 사용 내역 목록 화면.
export default function AiClientResultsPage() {
    const [results, setResults] = useState(null);
    const [error, setError] = useState('');

    // 사용 내역 목록을 불러온다.
    const load = useCallback(async () => {
        setError('');
        setResults(null);
        try {
            setResults(await getAiClientResults());
        } catch (loadError) {
            setError(loadError.message);
        }
    }, []);

    useEffect(() => { load(); }, [load]);

    return (
        <>
            <AdminPageHeader title="AI 내담자 결과" count={results?.length} />
            {results ? <AdminTable columns={COLUMNS} rows={results} rowKey="instance_id" getRowLink={toDetailPath} /> : <LoadStatus error={error} onRetry={load} />}
        </>
    );
}
